module.exports = __webpack_public_path__ + "static/media/sunrise3.273b14d5.jpg";